import PictureComponent from "components/core/picture/picture-component";
import Title from "segments/desktop/core-components/title/title";
import { XS } from "constants/sizes";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { StyledProductCardTitle } from "./product-card-title.scss";

const ProductCardTitle = ({ color, productImage, body, title }) => (
  <StyledProductCardTitle className="product-card-title">
    <PictureComponent src={productImage} />
    <div className="card-title-text">
      <Title titleColor={color} titleClassName="main-title" title={title} />
      <Paragraph bodyColor="asphalt" body={body} textSize={XS} />
    </div>
  </StyledProductCardTitle>
);

export default ProductCardTitle;
